import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'apply-leave',
      title: 'Apply for Leave',
      description: 'Submit new leave request',
      icon: 'CalendarPlus',
      color: 'primary',
      action: () => navigate('/leave-management')
    },
    {
      id: 'salary-sheet',
      title: 'View Salary Sheet',
      description: 'Access pay stubs & earnings',
      icon: 'DollarSign',
      color: 'success',
      action: () => console.log('View salary sheet')
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary/5 border-primary/10 hover:bg-primary/10 text-primary',
      success: 'bg-success/5 border-success/10 hover:bg-success/10 text-success',
      accent: 'bg-accent/5 border-accent/10 hover:bg-accent/10 text-accent',
      secondary: 'bg-secondary/5 border-secondary/10 hover:bg-secondary/10 text-secondary'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  const getIconColor = (color) => {
    const colorMap = {
      primary: 'var(--color-primary)',
      success: 'var(--color-success)',
      accent: 'var(--color-accent)',
      secondary: 'var(--color-secondary)'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Quick Actions</h2>
        <Button variant="ghost" size="sm">
          <Icon name="MoreHorizontal" size={16} />
        </Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.action}
            className={`
              p-4 rounded-lg border transition-smooth text-left group
              ${getColorClasses(action?.color)}
            `}
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`
                w-10 h-10 rounded-lg flex items-center justify-center
                ${action?.color === 'primary' ? 'bg-primary/10' :
                  action?.color === 'success' ? 'bg-success/10' :
                  action?.color === 'accent'? 'bg-accent/10' : 'bg-secondary/10'}
              `}>
                <Icon 
                  name={action?.icon} 
                  size={20} 
                  color={getIconColor(action?.color)}
                />
              </div>
              <Icon 
                name="ArrowUpRight" 
                size={16} 
                color="var(--color-muted-foreground)"
                className="opacity-0 group-hover:opacity-100 transition-smooth"
              />
            </div>
            
            <h3 className="font-medium text-foreground mb-1 group-hover:text-current">
              {action?.title}
            </h3>
            <p className="text-sm text-muted-foreground">
              {action?.description}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;